export class ShiftPlan {
    constructor({
          id = null,
          code= '', 
          locId= '', 
          locName= ``, 
          day= ``,
          shiftConfId= ``,
          shiftName= ``,
          shiftStartTime= ``,
          shiftEndTime= ``,
          matId= '', 
          matName= '', 
          output= '',
          operationRate='',
          qualitySpeId1= ``,
          qualitySpeCode1= ``,   
          qualitySpeUpLimit1= '',
          qualitySpeLowLimit1= '',    
          qualitySpeId2= ``,
          qualitySpeCode2= ``,   
          qualitySpeUpLimit2= '',
          qualitySpeLowLimit2= '',    
          status= '',

          dayStr= '',
          shiftStartTimeStr= '',
          shiftEndTimeStr= '',
          qualitySpe1= '',
          qualitySpe2= '',
          
      } = {}) {
      this.id = id;
      this.code = code;
      this.locId = locId;
      this.locName = locName;
      this.day = day;
      this.shiftConfId = shiftConfId;      
      this.shiftName =  shiftName;
      this.shiftStartTime =  shiftStartTime;
      this.shiftEndTime =  shiftEndTime;      
      this.matId = matId;
      this.matName = matName;        
      this.output = output;
      this.operationRate = operationRate;
      this.qualitySpeId1 = qualitySpeId1;
      this.qualitySpeCode1 = qualitySpeCode1;
      this.qualitySpeUpLimit1 = qualitySpeUpLimit1;
      this.qualitySpeLowLimit1 = qualitySpeLowLimit1;
      this.qualitySpeId2 = qualitySpeId2;
      this.qualitySpeCode2 = qualitySpeCode2;
      this.qualitySpeUpLimit2 = qualitySpeUpLimit2;
      this.qualitySpeLowLimit2 = qualitySpeLowLimit2;
      this.status = status;

      this.dayStr = dayStr;
      this.shiftStartTimeStr = shiftStartTimeStr;
      this.shiftEndTimeStr = shiftEndTimeStr;
      this.qualitySpe1 = qualitySpe1;
      this.qualitySpe2 = qualitySpe2;

    }
  }
  export function gridFields() {
    return Object.freeze([ 
        {
            key: 'code',
            label: 'lbl.shiftPlan.code',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'locName',
            label: 'lbl.shiftPlan.locName',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
          key: 'dayStr',
          label: 'lbl.shiftPlan.day',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'shiftName',
          label: 'lbl.shiftPlan.shiftName',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'shiftStartTimeStr',
          label: 'lbl.shiftPlan.shiftStartTime',
          form: {
            type: 'input'
          }
        },
        {
          key: 'shiftEndTimeStr',
          label: 'lbl.shiftPlan.shiftEndTime',
          form: {
            type: 'input'
          }
        },
        {
          key: 'matName',
          label: 'lbl.shiftPlan.matName',
          form: {
            type: 'input'
          }
        },
        {
          key: 'output',
          label: 'lbl.shiftPlan.output',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'operationRate',
          label: 'lbl.shiftPlan.operationRate',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'qualitySpe1',
          label: 'lbl.shiftPlan.qualitySpe1',
          form: {
            type: 'input'
          }
        },
        {
          key: 'qualitySpe2',
          label: 'lbl.shiftPlan.qualitySpe2',
          form: {
            type: 'input'
          }
        },
        {
          key: 'status',
          label: 'lbl.shiftPlan.status',
          sortable: true,
          form: {
            type: 'select',
            options: [    
                { value: null, text:  ''  },            
                { value: 'Y', text:  '激活' },
                { value: 'N', text:  '未激活' },                          
              ]            
          }
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new ShiftPlan()).map(i => 'entity.' + i));

  export const filterFields = [
    'filter.codeFilter',
    'filter.locNameFilter',
    'filter.startDateFilter',
    'filter.endDateFilter',
    'filter.shiftFilter',
    'filter.statusFilter'
  ];
  export const filter = {
    'codeFilter': "",
    'locNameFilter': "",
    'startDateFilter': "",
    'endDateFilter': "",
    'shiftFilter': "",
    'statusFilter': ""
  };